import React, { useEffect, useState } from 'react'
import TextAreaCustom from '../../../../components/elements/TextAreaCustom'
import InputCustom from '../../../../components/elements/InputCustom'
import SelectDropDown from '../../../../components/elements/SelectDropDown'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar'
import Suppliers from './Suppliers'
import TabsTwo from '../../../../components/general/general-component/tabs/TabsTwo'
import AddSupplier from '../../suppliers/AddSupplier'
import { postSupply } from '../../../../store/Actions/ActionSupply'
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { loadSupplierss } from '../../../../store/Actions/ActionSuppliers'
import { loadProducts } from '../../../../store/Actions/ActionProducts'
import { loadProjects } from '../../../../store/Actions/ActionProjects'
import { VariableSuppliers } from './VariableSuppliers'

function ProductSupplier({ translate, noBorder }) {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { state, setStateCustom, setLoad } = VariableSuppliers()
    const { projects, loadingProjects, products, loadingProducts, suppplierss, loadingSuppplierss } = useSelectorCustom()
    const [arrProjects, setArrProjects] = useState([])
    const [arrProducts, setArrProducts] = useState([])
    const [arrSuppplierss, setArrSuppplierss] = useState([])
    const [type, setType] = useState('Add Supply')
    const [open_supplier, setOpenSupplier] = useState(false)
    const [fields1, setFields1] = useState([{ file_path: '', notes: '' }])
    useEffect(() => {
        dispatch(loadSupplierss())
        dispatch(loadProducts())
        dispatch(loadProjects())
    }, []);
    useEffect(() => {
        setArrProjects(projects?.map((project) => ({
            value: project?.id,
            label: project?.name
        })))
    }, [projects])
    useEffect(() => {
        setArrProducts(products?.map((product) => ({
            value: product?.id,
            label: product?.name
        })))
    }, [products])
    useEffect(() => {
        setArrSuppplierss(suppplierss?.map((suppplier) => ({
            value: suppplier?.id,
            label: suppplier?.first_name + ' ' + suppplier?.last_name
        })))
    }, [suppplierss])
    const handleFieldChange = (index, field, value) => {
        const newFields = [...fields1]
        newFields[index][field] = value
        setFields1(newFields)
    }
    const handleSectionClick = (sectionId) => {
        setType(sectionId);
    };
    const tabs = [
        {
            id: 1,
            name: translate('add_supply'),
            type: "Add Supply",
            icon: 'fa-solid fa-plus'
        },
        {
            id: 2,
            name: translate('view_supplies'),
            type: "View Supplies",
            icon: 'fa-solid fa-eye'
        },
    ]
    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(postSupply(state, fields1, setLoad));
    };
    return (
        <>
            <div className='config-warehouse' >
                <TabsTwo langLocal={langLocal} tabs={tabs} activeSection={type} handleSectionClick={handleSectionClick} />
                {
                    type == 'Add Supply' && (
                        <div className='inner-main'>
                            <p className='basic-pro' style={{ marginBottom: "0px" }} >{translate('material_supplier_details')}</p>
                            <div className='supplier-add' style={noBorder && { borderBottom: "none" }} >
                                <div className='d-flex' >
                                    <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select`} >
                                        <span>{translate('materials')}</span>
                                        <SelectDropDown
                                            options={arrProducts}
                                            varr={state?.material_id}
                                            setVarr={(value) => setStateCustom('material_id', value)}
                                            loadingList={loadingProducts}
                                        />
                                    </div>
                                    <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select`} >
                                        <span>{translate('projects')}</span>
                                        <SelectDropDown
                                            options={arrProjects}
                                            varr={state?.company_project_id}
                                            setVarr={(value) => setStateCustom('company_project_id', value)}
                                            loadingList={loadingProjects}
                                        />
                                    </div>
                                    <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select`} >
                                        <span>{translate('supplier')}</span>
                                        <SelectDropDown
                                            options={arrSuppplierss}
                                            varr={state?.supplier_id}
                                            setVarr={(value) => setStateCustom('supplier_id', value)}
                                            loadingList={loadingSuppplierss}
                                        />
                                        <span style={{
                                            color: "#7bb5e5", fontWeight: "bold", cursor: "pointer"
                                        }} onClick={() => setOpenSupplier(true)} >{translate('add_new_supplier')}</span>
                                    </div>
                                </div>
                            </div>

                            <div /*className='supplier-add'*/ style={noBorder && { borderBottom: "none" }} >
                                <div className='d-flex' >
                                    <div style={{ width: '31.8%' }} >
                                        <InputCustom
                                            label='qty'
                                            iconType='pencil'
                                            type='number'
                                            onChange={(e) => setStateCustom('qty', e.target.value)}
                                        />
                                    </div>
                                    <div style={{ width: '31.8%' }} >
                                        <InputCustom
                                            label='cost'
                                            iconType='pencil'
                                            type='number'
                                            onChange={(e) => setStateCustom('cost', e.target.value)}
                                        />
                                    </div>
                                    <div className='one-select' >
                                        <span>{translate('currency')}</span>
                                        <SelectDropDown
                                            options={[{ value: 'dollar', label: "Dollar" }, { value: 'syrian_bound', label: "Syrian Bound" }]}
                                            varr={state?.currency}
                                            setVarr={(value) => setStateCustom('currency', value)}
                                        />
                                    </div>

                                    <div className='w-30' >
                                        <InputCustom
                                            label='date'
                                            iconType='pencil'
                                            type='date'
                                            onChange={(e) => setStateCustom('date_of_supply', e.target.value)}
                                        />
                                    </div>
                                    <div className='w-30' >
                                        <InputCustom
                                            label='time'
                                            iconType='pencil'
                                            type='time'
                                            onChange={(e) => setStateCustom('time_of_supply', e.target.value)}
                                        />
                                    </div>
                                    <div style={{ width: '31.8%' }} >
                                        <InputCustom
                                            label='place'
                                            iconType='pencil'
                                            type='text'
                                            onChange={(e) => setStateCustom('place_of_supply', e.target.value)}
                                        />
                                    </div>
                                    {fields1.map((field, index) => (
                                        <div className='w-30' >
                                            <InputCustom
                                                label='file'
                                                iconType='pencil'
                                                type='file'
                                                onChange={handleFieldChange}
                                                index={index}
                                            />
                                        </div>
                                    ))}
                                </div>
                                <div className='d-flex' style={{ marginTop: '-10px' }} >
                                    {fields1.map((field, index) => (
                                        <div style={{ width: '555px' }} >
                                            <TextAreaCustom
                                                label='notes'
                                                onChange={(e) => handleFieldChange(index, 'notes', e.target.value)}
                                                nameClass='textarea-general'
                                            />
                                        </div>
                                    ))}
                                    <div style={{ width: '555px' }} >
                                        <TextAreaCustom
                                            label='reason'
                                            onChange={(e) => setStateCustom('reason_of_supply', e.target.value)}
                                            nameClass='textarea-general'
                                        />
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: "20px" }} >
                                <button className='btn_top_table' onClick={handleSubmit} >
                                    {
                                        state?.Load ? "Loading ...": translate('save')
                                    }
                                </button>
                            </div>

                        </div>
                    )
                }
                {
                    type == 'View Supplies' && (
                        <div style={{ marginTop: "20px" }} >
                            <Suppliers />
                        </div>
                    )
                }
                {
                    open_supplier && (
                        <AddSupplier open={open_supplier} setOpen={setOpenSupplier} />
                    )
                }
            </div>
        </>
    )
}

export default ProductSupplier